import React from 'react'
import './style.css'
import { AiChatBotPageData } from '../../data/ai-chatbot-data'
import { Link } from 'react-router-dom'

const AreasWeServe = () => {
    return (
        <>
            <div className="area-we-serve-main-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className='blog-main-heading areas-we-serve-main-heading'>{AiChatBotPageData?.areaWeServeContent?.mainHeading}</h2>
                        </div>

                        <div className="col-xl-3 col-lg-3 col-md-6">
                            <ul className='area-we-serve-links'>
                                {AiChatBotPageData?.areaWeServeContent?.newyork?.map((list, index) => {
                                    return <li key={index}><Link to={list?.link}><i class="fa-solid fa-location-dot"></i> {list?.text}</Link></li>
                                })}
                            </ul>
                        </div>

                        <div className="col-xl-3 col-lg-3 col-md-6">
                            <ul className='area-we-serve-links'>
                                {AiChatBotPageData?.areaWeServeContent?.california?.map((list, index) => {
                                    return <li key={index}><Link to={list?.link}><i class="fa-solid fa-location-dot"></i> {list?.text}</Link></li>
                                })}
                            </ul>
                        </div>

                        <div className="col-xl-3 col-lg-3 col-md-6">
                            <ul className='area-we-serve-links'>
                                {AiChatBotPageData?.areaWeServeContent?.texas?.map((list, index) => {
                                    return <li key={index}><Link to={list?.link}><i class="fa-solid fa-location-dot"></i> {list?.text}</Link></li>
                                })}
                            </ul>
                        </div>

                        <div className="col-xl-3 col-lg-3 col-md-6">
                            <ul className='area-we-serve-links'>
                                {AiChatBotPageData?.areaWeServeContent?.florida?.map((list, index) => {
                                    return <li key={index}><Link to={list?.link}><i class="fa-solid fa-location-dot"></i> {list?.text}</Link></li>
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AreasWeServe